const toastTypes = {
  Success: 'success',
  Error: 'error',
  Warning: 'warning',
};

export default toastTypes;
